<template>
    <div class="l-search__title--sub">
        <img src="/assets/images/icon/icon-heart-pink.svg" height="16" width="16"/>
        お気に入り表示
        <label class="switch-container">
            <input
                type="checkbox"
                :checked="isFavorite"
                @change="toggleFavorite"
            />
            <span class="slider round"></span>
        </label>

    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'SwitchFavorite',
    props: {
        isFavorite: {
            type: Boolean,
            default: false,
        },
        toggleFavorite: {
            type: Function,
            required: true,
        },
    },
});
</script>
